import React, { useEffect, useRef, useState } from 'react';
import "./EducationHub.css";
import searchIcon from "../assets/images/edu/search.png";
import buildingImg from "../assets/images/edu/freestandinghouse.png";
import processIcon from "../assets/images/edu/process.png";
import tradieIcon from "../assets/images/edu/tradie.png";
import costIcon from "../assets/images/edu/cost.png";
import estimatorIcon from "../assets/images/edu/estimator.png";

const EducationHub = () => {
  return (
    <div className="education-container">
      {/* Hero Section */}
      <section className="hero">
        <h1>Build Start Education Hub</h1>
        <div className="search-bar">
          <img src={searchIcon} alt="Search Icon" className="search-icon" />
          <input type="text" placeholder="Search education learning..." />
        </div>
      </section>

      {/* Main Content Sections */}
      <section className="info-section">
        <img src={buildingImg} alt="Building Process" className="main-image" />
      </section>

      {/* Learning Categories */}
      <section className="categories">
        <div className="category">
          <img src={processIcon} alt="Building Process" />
          <h3>Understanding the Building Process</h3>
          <p>Learn about step-by-step construction phases.</p>
        </div>
        <div className="category">
          <img src={tradieIcon} alt="Choosing a Tradie" />
          <h3>Choosing a Tradie</h3>
          <p>Tips for selecting qualified professionals.</p>
        </div>
        <div className="category">
          <img src={costIcon} alt="Cost & Timeline" />
          <h3>Cost & Timeline</h3>
          <p>Understand project costs and timelines.</p>
        </div>
        <div className="category">
          <img src={estimatorIcon} alt="Find a Tradie Estimator" />
          <h3>Find a Tradie Estimator</h3>
          <p>Estimate costs and find top-rated professionals.</p>
        </div>
      </section>
    </div>
  );
};

export default EducationHub;
